import React from "react";
import classes from "./Sectors.module.scss";
import SectorCard from "./SectorCard.tsx";

export interface ISectorCard {
  image: string;
  title: string;
  text: string;
  id?: number;
  link?: string;
}

const Sectors: React.FC<{
  cards: ISectorCard[];
  title: string;
  subtitle?: string;
  smallCards?: boolean;
}> = ({ cards, title, subtitle = "", smallCards = false }) => {
  return (
    <div className={classes["container"]}>
        <div
            className={`${classes["cards-container"]}`}
        >
            <div className={classes["text-container"]}>
                <h2 className={classes["title"]}>{title}</h2>
                <p className={classes.subtitle}>{subtitle}</p>
            </div>
            {cards.map((item) => (
                <SectorCard key={item.id}
                    image={item.image}
                    title={item.title}
                    text={item.text}
                    smallCards={smallCards}
                    link={item.link}
                />
            ))}
        </div>
    </div>
  );
};

export default Sectors;
